<template>

<header id="header">
    <!-- Top Bar -->
    <div class="header-top d-none d-lg-block border-bottom" style="background-color: #f4f4f4;">
        <div class="container-fluid px-xl-5 d-flex justify-content-between align-items-center py-1">
            <div class="top-socials d-flex gap-3">
                <a href="mailto:empaqueslupa@gmail.com" class="text-dark"><font-awesome-icon icon="envelope" style="font-size: 11px;" /></a>
                <a href="https://www.instagram.com/empaqueslupa/" target="_blank" class="text-dark"><font-awesome-icon :icon="['fab', 'instagram']" style="font-size: 11px;" /></a>
            </div>
            <div class="top-message text-uppercase" style="font-size: 10px; color: #333; font-weight: 500;">
                Expertos en empaques
            </div>
            <div class="top-lang d-flex align-items-center cursor-pointer text-dark" style="font-size: 11px;">
                <span>Español</span>
                <font-awesome-icon icon="chevron-down" class="ms-1" style="font-size: 8px;" />
            </div>
        </div>
    </div>

    <!-- Middle Bar -->
    <div class="header-middle bg-white border-bottom py-2 py-md-3">
        <div class="container-fluid px-2 px-md-4 px-xl-5">
            <div class="row align-items-center g-2">
                <div class="col-6 col-lg-2 d-flex align-items-center">
                    <router-link :to="{name:'home'}" class="logo me-2 me-md-4">
                        <img src="/img/LOGO-LUPA.jpg" alt="LUPA" class="logo-img" style="max-height: 45px;" />
                    </router-link>
                </div>
                <div class="col-lg-5 d-none d-lg-block">
                    <div class="search-wrap">
                        <div class="input-group search-group position-relative border" style="border-radius: 4px; overflow: hidden; border-color: #ddd !important; background-color: #ffffff;">
                            <input type="text" v-model="searchText" @keyup.enter="ejecutarBusqueda" @input="ejecutarBusqueda" class="form-control border-0 py-2 ps-3 pe-5 shadow-none" 
                                   style="font-size: 1rem; color: #111111 !important; background-color: #ffffff !important;" 
                                   placeholder="¿Qué estás buscando?" />
                            <div class="position-absolute top-50 end-0 translate-middle-y pe-3 d-flex align-items-center gap-3" style="z-index: 10;">
                                <font-awesome-icon icon="camera" class="text-secondary" style="cursor: pointer;" />
                                <font-awesome-icon icon="search" class="text-secondary" style="cursor: pointer;" @click="ejecutarBusqueda" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-5 d-flex justify-content-end align-items-center gap-2 gap-md-4">
                    <div class="header-actions text-dark d-flex gap-3 gap-md-4 align-items-center">
                        <a href="#" class="text-decoration-none d-none d-md-flex align-items-center">
                            <font-awesome-icon icon="map-marker-alt" class="fs-5 text-secondary me-1" />
                            <span class="text-primary text-decoration-underline" style="font-size: 0.85rem; font-weight: 600;">Ubicación</span>
                        </a>
                        <router-link :to="{name: 'checkout'}" class="text-dark text-decoration-none d-flex align-items-center">
                            <span class="badge rounded-circle d-flex text-white align-items-center justify-content-center me-1" style="width: 22px; height: 22px; font-size: 0.8rem; background-color: #713083 !important;">{{(productsInCart && productsInCart.length) || 0}}</span>
                            <font-awesome-icon icon="shopping-cart" class="fs-4 text-dark" />
                        </router-link>
                        <div class="d-none d-xl-flex text-dark align-items-center justify-content-center px-2" style="border-left: 1px solid #ddd; border-right: 1px solid #ddd; height: 35px; line-height: 1;">
                            <span class="text-muted text-uppercase text-center" style="font-size: 10px;">Programa<br><strong class="text-dark" style="font-size: 12px; font-weight: 800;">Puntos</strong></span>
                        </div>
                        <a href="#" class="text-dark text-decoration-none d-none d-md-flex align-items-center">
                            <font-awesome-icon icon="user" class="fs-5 text-dark me-1" />
                            <span style="font-size: 0.85rem; font-weight: 600;">Mi Cuenta</span>
                        </a>
                    </div>
                    <button class="menu-toggle d-inline-block border-0 bg-transparent ms-1 ms-md-3 p-1" @click="menu = !menu" aria-label="Menú">
                        <font-awesome-icon :icon="menu ? 'times' : 'bars'" class="fs-3 text-dark" />
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Search Bar -->
    <div class="mobile-search-bar bg-white border-bottom py-2 px-3 d-block d-lg-none">
        <div class="input-group search-group position-relative border rounded" style="border-color: #ddd !important; background-color: #ffffff;">
            <input type="text" v-model="searchText" @keyup.enter="ejecutarBusqueda" @input="ejecutarBusqueda" class="form-control border-0 py-1 ps-3 pe-5 shadow-none" 
                   style="font-size: 0.9rem; color: #111111 !important; background-color: #ffffff !important;" 
                   placeholder="¿Qué estás buscando?" />
            <div class="position-absolute top-50 end-0 translate-middle-y pe-3 d-flex align-items-center gap-2" style="z-index: 10;">
                <font-awesome-icon icon="search" class="text-secondary" style="cursor: pointer;" @click="ejecutarBusqueda" />
            </div>
        </div>
    </div>

    <!-- Bottom Bar (Nav Desktop) -->
    <div class="header-bottom bg-white border-bottom d-none d-lg-block header-mega-nav" :class="{ fixed: isFixed }">
        <div class="container position-relative d-flex justify-content-between align-items-center py-1">
            <nav class="nav-wrap flex-grow-1">
                <ul class="nav d-flex flex-nowrap list-unstyled m-0 p-0">
                    <li v-for="cat in categories" :key="cat.id" class="nav-item position-static group-hover-trigger">
                        <a class="nav-link text-nowrap fw-bold" @click="getProductos(cat.id)">
                            {{cat.nombre}} <font-awesome-icon icon="chevron-down" class="ms-1 extra-small" />
                        </a>
                        
                        <!-- Mega Menu Dropdown -->
                        <div class="mega-menu-dropdown w-100 position-absolute start-0 bg-white shadow py-3 px-4" v-if="cat.sublevels && cat.sublevels.length > 0" style="border-top: 3px solid #713083; top: 100%; max-height: 82vh; overflow-y: auto;">
                            <div class="row w-100 m-0 text-start">
                                <div class="col-lg-3 col-md-4 col-sm-6 mb-3 px-2" v-for="subcat in cat.sublevels" :key="subcat.id">
                                    <h6 class="fw-bold mb-1 border-bottom pb-1 text-uppercase d-block" style="color: #0099cc; cursor: pointer; font-size: 0.82rem; line-height: 1.2;" @click="getProductos(subcat.id)">
                                        {{subcat.nombre}} <font-awesome-icon icon="chevron-right" style="font-size: 8px;"/>
                                    </h6>
                                    <!-- Nivel 2 -->
                                    <ul class="list-unstyled ms-0 mb-0" v-if="subcat.sublevels && subcat.sublevels.length > 0">
                                        <li class="mb-1 mt-1" v-for="subsub in subcat.sublevels" :key="subsub.id">
                                            <a class="text-dark text-decoration-none subcat-link fw-bold d-block py-0" @click="getProductos(subsub.id)" style="font-size: 0.78rem; line-height: 1.25; cursor: pointer;">{{subsub.nombre}}</a>
                                            <!-- Nivel 3 -->
                                            <ul class="list-unstyled ms-2 my-0" v-if="subsub.sublevels && subsub.sublevels.length > 0">
                                                <li class="mb-0 py-0" v-for="lvl3 in subsub.sublevels" :key="lvl3.id">
                                                    <a class="text-secondary text-decoration-none subcat-link d-block py-0" @click="getProductos(lvl3.id)" style="font-size: 0.75rem; line-height: 1.2; cursor: pointer;">
                                                        <span class="text-muted me-1" style="font-size: 0.7rem;">↳</span>{{lvl3.nombre}}
                                                    </a>
                                                    <!-- Nivel 4 -->
                                                    <ul class="list-unstyled ms-2 my-0" v-if="lvl3.sublevels && lvl3.sublevels.length > 0">
                                                        <li class="mb-0 py-0" v-for="lvl4 in lvl3.sublevels" :key="lvl4.id">
                                                            <a class="text-muted text-decoration-none subcat-link d-block py-0" @click="getProductos(lvl4.id)" style="font-size: 0.73rem; line-height: 1.2; cursor: pointer;">
                                                                <span class="text-muted me-1" style="font-size: 0.65rem;">↳</span>{{lvl4.nombre}}
                                                            </a>
                                                            <!-- Nivel 5 -->
                                                            <ul class="list-unstyled ms-2 my-0" v-if="lvl4.sublevels && lvl4.sublevels.length > 0">
                                                                <li class="mb-0 py-0" v-for="lvl5 in lvl4.sublevels" :key="lvl5.id">
                                                                    <a class="text-muted text-decoration-none subcat-link d-block py-0" @click="getProductos(lvl5.id)" style="font-size: 0.70rem; line-height: 1.2; cursor: pointer;">
                                                                        <span class="text-muted me-1" style="font-size: 0.65rem;">↳</span>{{lvl5.nombre}}
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </li>
                </ul>
            </nav>
            <div class="info-widgets d-flex align-items-center gap-2 ms-3">
                <div class="info-widget d-flex align-items-center bg-light px-2 py-1 rounded shadow-sm border">
                    <font-awesome-icon :icon="['fab', 'whatsapp']" class="info-icon whatsapp-icon me-1" />
                    <span class="fw-bold text-dark" style="font-size: 11px;">Soporte</span>
                </div>
                <div class="info-widget d-flex align-items-center bg-light px-2 py-1 rounded shadow-sm border ms-1">
                    <font-awesome-icon icon="box" class="info-icon me-1" />
                    <span class="fw-bold text-dark" style="font-size: 11px;">Personalizar</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Drawer Navigation -->
    <div v-if="menu" class="mobile-nav-backdrop" @click="menu = false"></div>
    <transition name="slide">
        <div class="hamburger-menu" v-if="menu">
            <div class="mobile-drawer-header d-flex justify-content-between align-items-center pb-3 border-bottom mb-3">
                <h5 class="m-0 fw-bold text-dark" style="color: #713083 !important;">Empaques Lupa</h5>
                <button class="btn-close shadow-none" @click="menu = false"></button>
            </div>

            <div class="mobile-quick-actions d-flex gap-2 mb-3">
                <a href="#" class="btn btn-outline-dark btn-sm flex-fill d-flex align-items-center justify-content-center gap-1">
                    <font-awesome-icon icon="user" />
                    <span>Mi Cuenta</span>
                </a>
                <a href="#" class="btn btn-outline-secondary btn-sm flex-fill d-flex align-items-center justify-content-center gap-1">
                    <font-awesome-icon icon="map-marker-alt" />
                    <span>Ubicación</span>
                </a>
            </div>

            <ul class="mobile-main-nav list-unstyled m-0 p-0 mb-3">
                <li @click="menu = false"><router-link :to="{name:'home'}" class="nav-item-link">Inicio</router-link></li>
                <li @click="menu = false"><router-link :to="{name:'nosotros'}" class="nav-item-link">Quiénes Somos</router-link></li>
                <li @click="menu = false"><router-link :to="{name:'contacto'}" class="nav-item-link">Contacto</router-link></li>
            </ul>

            <!-- Mobile Categories Accordion -->
            <div class="mobile-categories-tree border-top pt-3">
                <h6 class="fw-bold text-uppercase text-muted mb-2" style="font-size: 0.75rem; letter-spacing: 1px;">Categorías</h6>
                <div class="categories-accordion">
                    <div v-for="cat in categories" :key="cat.id" class="category-acc-item border-bottom py-2">
                        <div class="d-flex justify-content-between align-items-center" @click="toggleCat(cat.id)">
                            <span class="cat-title fw-bold text-dark" style="font-size: 0.9rem;" @click.stop="getProductos(cat.id)">
                                {{ cat.nombre }}
                            </span>
                            <font-awesome-icon 
                                v-if="cat.sublevels && cat.sublevels.length > 0"
                                :icon="expandedCatId === cat.id ? 'chevron-up' : 'chevron-down'" 
                                class="text-secondary" 
                                style="font-size: 0.8rem; cursor: pointer; padding: 4px;"
                            />
                        </div>

                        <!-- Subcategories -->
                        <div v-if="expandedCatId === cat.id && cat.sublevels && cat.sublevels.length > 0" class="subcat-acc-list ms-2 mt-2">
                            <div v-for="subcat in cat.sublevels" :key="subcat.id" class="mb-2">
                                <span class="fw-bold text-primary d-block" style="font-size: 0.82rem; cursor: pointer;" @click="getProductos(subcat.id)">
                                    {{ subcat.nombre }}
                                </span>
                                <ul v-if="subcat.sublevels && subcat.sublevels.length > 0" class="list-unstyled ms-2 my-1">
                                    <li v-for="subsub in subcat.sublevels" :key="subsub.id" class="py-1">
                                        <a class="text-dark text-decoration-none d-block" style="font-size: 0.78rem;" @click="getProductos(subsub.id)">
                                            ↳ {{ subsub.nombre }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</header>
</template>

<script>
  import { mapState } from 'vuex'
  import MenuItem from '../MenuItem.vue'

  export default {
    components: { MenuItem },
    name: 'eheader',
    data() {
      return {
        menu: false,
        isFixed: false,
        buscar: '',
        searchText: '',
        expandedCatId: null,
        redes: [
          {'nombre':'facebook', 'icono':'fab fa-facebook', 'link':'https://www.facebook.com/agencialupasas/?viewas=&show_switched_toast=false&show_switched_tooltip=false&show_podcast_settings=false'},
          {'nombre':'instagram', 'icono':'fab fa-instagram', 'link':'https://www.instagram.com/empaqueslupa/'},
        ]
      }
    },
    computed: {
      ...mapState(['productsInCart','categories'])
    },
    methods: {
      handleScroll() {
        this.isFixed = window.scrollY >= 50;
      },
      getProductos(id) {
        this.menu = false;
        this.$store.dispatch('getProductosCat', id)
        this.$router.push('/tienda/' + id).catch(() => {})
      },
      toggleCat(id) {
        this.expandedCatId = this.expandedCatId === id ? null : id;
      },
      ejecutarBusqueda() {
        let term = this.searchText ? this.searchText.trim() : '';
        this.$store.commit('clearCategoryFilter');
        this.$store.commit('search', term);
        if (this.$route.name !== 'store' && this.$route.path !== '/tienda') {
          this.$router.push('/tienda').catch(() => {});
        }
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  }
</script>

<style lang="scss" scoped>
#header {
  width: 100%;
  z-index: 1000;
  position: relative;
}

/* TOP BAR */
.header-top {
  a {
    transition: all 0.2s;
    &:hover { color: #713083 !important; }
  }
}

/* MIDDLE BAR */
.header-middle {
  background: #fff;
}

.logo-img {
  max-height: 50px;
  width: auto;
  transition: all 0.3s ease;
}

.search-group {
  .input-group-text {
    border-right: 0;
  }
  input {
    box-shadow: none !important;
    &:focus {
      border-color: #dee2e6;
    }
  }
}

/* BOTTOM BAR / NAV */
.header-bottom {
  background: #fff;
  transition: all 0.3s ease;
  
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    box-shadow: 0 4px 15px rgba(0,0,0,0.08);
    z-index: 9999;
  }
}

.nav {
  .nav-item {
    .nav-link {
      color: #333;
      font-weight: 700;
      text-transform: uppercase;
      font-size: 12px;
      padding: 15px 18px;
      cursor: pointer;
      white-space: nowrap;
      
      &:hover {
        color: #713083 !important;
      }
    }
  }
}

.header-mega-nav .nav-item {
  position: static !important;
}

.mega-menu-dropdown {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 1050;
  pointer-events: none;
}

.group-hover-trigger:hover .mega-menu-dropdown {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}

.subcat-link:hover {
  color: #0099cc !important;
  text-decoration: underline !important;
}

.info-widgets {
  flex-shrink: 0;
  span {
    white-space: nowrap;
  }
}

.info-icon {
  font-size: 18px;
  color: #333;
  
  &.whatsapp-icon {
    color: #33e034;
  }
}

.extra-small {
  font-size: 10px;
}

/* MOBILE TOGGLE & DRAWER */
.menu-toggle {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-nav-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  backdrop-filter: blur(2px);
}

.hamburger-menu {
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  width: 310px;
  max-width: 85vw;
  height: 100vh;
  z-index: 9999;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.2);
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.nav-item-link {
  color: #333;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  display: block;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.2s;

  &:hover {
    color: #713083;
  }
}

/* Slide Transition */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>